import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ActiveUserLocalDataService } from '../../../shared/services/active-user-local-data.service';
import { VisualDeffectsService } from '../../../shared/services/viusal-deffects.service';
import { PostVisualDamageRequest } from '../../../shared/models/visual-deffects.models';
import { GetActiveVoucherDto } from '../../../shared/models/courier.models';
import { TranslateService } from '@ngx-translate/core';

@Component({
  templateUrl: 'visual-damage-post-damage.component.html',
  styleUrls: ['./visual-damage-post-damage.component.scss']
})
export class VisualDamagePostDamageComponent implements OnInit {
  accidentDescription: string = '';
  damageDescription: string = '';
  accidentPlace: string = '';
  choosedDate: Date = new Date();
  startHours: number = new Date().getHours();
  startMinutes: number = Math.round(new Date().getMinutes() / 5) * 5;
  loadedFiles: any[] = [];
  imageDict: { [key: string]: string } = {};
  hoursArray: number[] = Array.from({ length: 24 }, (_, i) => i);
  minutesArray: number[] = Array.from({ length: 12 }, (_, i) => i * 5);
  uploadedFiles: any[] = [];
  visualDamageDeffectPosition: string = '';
  type: string = '';
  loading: boolean = true;
  voucher: GetActiveVoucherDto | null = null;

  constructor(
    public activeUserLocalDataService: ActiveUserLocalDataService,
    private visualDeffectsService: VisualDeffectsService,
    private router: Router,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    const url = this.router.url;
    if (url.endsWith('/service-visual-damage-post-damage')) {
      this.voucher = this.activeUserLocalDataService.activeServiceVoucher;
    } else if (url.endsWith('/visual-damage-post-damage')) {
      this.voucher = this.activeUserLocalDataService.getActiveCourierVoucher();
    }

    if (!this.voucher) {
      this.router.navigate(['/voucher']);
      return;
    }

    this.visualDamageDeffectPosition = this.activeUserLocalDataService.visualDamageDeffectPosition || '';
    this.type = this.activeUserLocalDataService.visualDamageType;
    this.loading = false;
  }

  save() {
    const request: PostVisualDamageRequest = {
      accidentDescription: this.accidentDescription,
      accidentPlace: this.accidentPlace,
      carId: this.voucher?.carsId,
      visualDamageType: this.type,
      deffectPositionId: this.activeUserLocalDataService.visualDamageDeffectPositionId ?? undefined,
      damageDescription: this.damageDescription,
      secondCar: '',
      workTime: this.choosedDate,
      images: this.loadedFiles
    };

  
    this.visualDeffectsService.postVisualDamage(request).subscribe(() => {
      this.router.navigate(['/voucher']);
    });
  }

  backClick() {
    if (this.voucher?.isServiceVoucher) {
      this.router.navigate(['/service-visual-damage-deffect-position-pick']);
    } else {
      this.router.navigate(['/visual-damage-deffect-position-pick']);
    }
  }

  async onFileUploaderValueChanged(event: any) {
    const files = event.value;
    for (const file of files) {
      if (file) {
        const reader = new FileReader();
        reader.onload = async () => {
          const arrayBuffer = reader.result as ArrayBuffer;
          const image = new Uint8Array(arrayBuffer);
  
          const resizedImage = await this.resizeImage(image);
  
          const base64Image = this.arrayBufferToBase64(resizedImage);
  
          this.loadedFiles.push({
            image: base64Image,
            fileName: file.name
          });
        };
        reader.readAsArrayBuffer(file);
      }
    }
  
    this.uploadedFiles = [...this.uploadedFiles, ...files];
  }

  arrayBufferToBase64(buffer: Uint8Array): string {
    let binary = '';
    const bytes = new Uint8Array(buffer);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
  }
  
  async resizeImage(image: Uint8Array): Promise<Uint8Array> {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
  
    if (!ctx) {
      throw new Error('Failed to get 2D context');
    }
  
    const img = new Image();
  
    return new Promise((resolve, reject) => {
      img.onload = () => {
        const maxSize = 1024;
        let width = img.width;
        let height = img.height;
  
        if (width > height) {
          if (width > maxSize) {
            height *= maxSize / width;
            width = maxSize;
          }
        } else {
          if (height > maxSize) {
            width *= maxSize / height;
            height = maxSize;
          }
        }
  
        canvas.width = width;
        canvas.height = height;
        ctx.drawImage(img, 0, 0, width, height);
  
        canvas.toBlob((blob) => {
          if (blob) {
            const reader = new FileReader();
            reader.onload = () => {
              resolve(new Uint8Array(reader.result as ArrayBuffer));
            };
            reader.onerror = reject;
            reader.readAsArrayBuffer(blob);
          } else {
            reject(new Error('Failed to create blob from canvas'));
          }
        }, 'image/jpeg');
      };
      img.onerror = reject;
      img.src = URL.createObjectURL(new Blob([image]));
    });
  }

  deleteFile(index: number) {
    this.uploadedFiles.splice(index, 1);
    this.loadedFiles.splice(index, 1);
  }

  dayBack() {
    this.choosedDate.setDate(this.choosedDate.getDate() - 1);
  }

  dayForward() {
    this.choosedDate.setDate(this.choosedDate.getDate() + 1);
  }

  getPageTitle(): string {
    if (this.type === 'd') {
      return this.translate.instant('VisualDamageOrDefectRegistration');
    } else if (this.type === 'c') {
      return this.translate.instant('RoadTrafficAccidentDamageOrDefectRegistration');
    } else {
      return this.translate.instant('IncorrectType');
    }
  }
}